module.exports = __webpack_public_path__ + "static/staff-augmentation-6d79fc6c7cbcd7df1a06c170d1f30b79.svg";